module.exports = __webpack_public_path__ + "img/paypal.14e8e163.svg";